const defaults = {
  fromBoardUid: '',
  tabsData: [],
}

const filter = {
  namespaced: true,
  state: Object.assign({}, defaults),
  mutations: {
    setFromBoardUid(state, uid) {
      state.fromBoardUid = uid
    },
    setTabsData(state, val) {
      state.tabsData = val
    },
  },
  actions: {
    setFromBoardUid({ commit }, uid) {
      commit('setFromBoardUid', uid)
    },
    setTabsData({ commit }, val) {
      commit('setTabsData', val)
    },
  },
}

export default filter
